export class RequestItem {
    id = '';
    method = '';
    url = '';
    requestType = 'xhr';
    requestHeader = null;
    status = 0;
    statusText = '';
    readyState = 0;
    // See: https://github.com/HuolalaTech/page-spy-web/issues/390
    response = '__PLACEHOLDER_RESPONSE_DEFINED_BY_PAGE_SPY__';
    responseReason = null; // error response reason
    responseType = '';
    responseHeader = null;
    startTime = 0;
    endTime = 0;
    costTime = 0;
    /**
     * @deprecated please using `requestPayload`
     */
    postData = null;
    requestPayload = null;
    withCredentials = false;
    // For EventSource
    lastEventId = '';
    constructor(id) {
        this.id = id;
    }
}
